import { createTheme } from "@mui/material/styles";
import palette from "./palette";
import components from "./components";
import typography from "./typography";
import "./overrides";

const getTheme = (direction: "ltr" | "rtl") => {
  return createTheme({
    direction,
    spacing: 10,
    typography,
    palette,
    // @ts-ignore
    components,
  });
};

export default getTheme;
